import { Component, Input } from '@angular/core';
import { DescribedImage } from '@planone/bau365/util-fair-data';
import { ImageFileTypes } from '@planone/shared/util-pipelines';

import { ItemType } from '../../../page-watchlist/page-watchlist.model';

@Component({
  selector: 'bau365-watchlist-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
})
export class ImageComponent {
  @Input() alt?: string;
  @Input() image?: DescribedImage;
  @Input() category?: ItemType;

  ImageFileTypes = ImageFileTypes;
}
